import React, { useState } from "react";
import CompanyNavbar from "./CompanyNavbar";
import './card.css';
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function AddJobsPage() {
    const ID = Cookies.get("log_id");
    const [job,setJob] = useState("");
    const [description,setDescription] = useState("");
    const [Skills,setSkills] = useState("");
    const [Location,setLocation] = useState("");
    const [Experience,setExperience] = useState("");
    const [number,setNumber] = useState("");
    const [last,setLast] = useState("");
    const [join,setJoin] = useState("");
    const [jobtype,setType] = useState("");
    const navigate = useNavigate();
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
    });
    function handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('job',job);
        formdata.append('description',description);
        formdata.append('skills',Skills);
        formdata.append('location',Location);
        formdata.append('experience',Experience);
        formdata.append('number',number);
        formdata.append('last',last);
        formdata.append('join',join);
        formdata.append('type',jobtype);
        axios.post(`${url.path}/add_job/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Job Added Successfully..'
                })
                navigate("/view_jobs_company");
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Add New Job</h1>
                </div>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Job Title</label>
                            <input type="text" value={job} onChange={(e) =>setJob(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Job Description</label>
                            <input type="text" value={description} onChange={(e) =>setDescription(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Skills Required</label>
                            <input type="text" value={Skills} onChange={(e) =>setSkills(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Location</label>
                            <input type="text" value={Location} onChange={(e) =>setLocation(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Experience Needed(eg:5 year in python)</label>
                            <input type="text" value={Experience} onChange={(e) =>setExperience(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Number of Vaccancy</label>
                            <input type="number" value={number} onChange={(e) =>setNumber(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Last Date To Apply</label>
                            <input type="date" value={last} onChange={(e) =>setLast(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Expected Joining Date</label>
                            <input type="date" value={join} onChange={(e) =>setJoin(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label className="lab2">Job Type</label>
                            <div className="radio-group">
                                <label>
                                    <input type="radio" name="job_type" value="OpenSource" id="opensource" onChange={(e) =>setType(e.target.value)} /> Open Source
                                </label>
                                <label>
                                    <input type="radio" name="job_type" value="ExactSource" id="exactsource" onChange={(e) =>setType(e.target.value)} /> Exact Source
                                </label>
                            </div>
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">ADD</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default AddJobsPage;